export const fr = {
  main: {
    color_hex: 'Couleur en notation hexadécimale, commencez par #',
    language: 'Français',
    restricted_field_name: 'Ce nom de champ est réservé et ne peut pas être utilisé',
    asset_type_required: "Sélectionnez au moins un type d'actif ou rendez le champ global",
    searchbar: 'Chercher (3 caractères min.)',
    title: 'Admin',
    logout: 'Déconnectez',
    english: 'anglais',
    dutch: 'néerlandais',
    french: 'français',
    spanish: 'espagnol',
    danish: 'danois',
    italian: 'italien',
    romanian: 'roumain',
    norwegian: 'norvégien',
    german: 'allemand',
    drop_image: 'Glissez votre image ici',
  },
  ra: {
    tree: {
      add_child_node: 'Ajouter une sous-catégorie',
      add_node_after: 'Ajouter une catégorie après',
      add_node_before: 'Ajouter une catégorie avant',
      close: 'Fermer',
      expand: 'Ouvrir',
    },
  },
  resources: {
    categories: {
      name: 'Catégorie |||| Catégories',
      fields: {
        name: 'Nom de catégorie',
      },
    },
    users: {
      name: 'Utilisateur |||| Utilisateurs',
      fields: {
        category: 'Catégorie',
        connection: 'Connexion',
        email: 'E-mail',
        familyName: 'Nom',
        firstName: 'Prénom',
        language: 'Langue',
        userRoles: 'Rôles',
      },
    },
    priorities: {
      name: 'Priorité |||| Priorités',
    },
    branding: {
      name: 'Logo',
    },
    invitations: {
      name: 'Invitation |||| Invitations',
      fields: {
        email: 'E-mail',
      },
    },
    'asset-types': {
      name: "Type d'actif |||| Types d'actifs",
      fields: {
        name: 'Nom',
      },
    },
    'asset-statuses': {
      name: "Statut de l'actif |||| Statuts de l'actif",
      fields: {
        name: 'Nom',
      },
    },
    'asset-custom-fields': {
      name: "Champ personnalisé de l'actif |||| Champs personnalisés de l'actif",
      fields: {
        name: 'Nom',
        globalField: "Global (tous les types d'actifs)",
        assetTypeIds: "Types d'actifs",
      },
    },
  },
}
